<template lang="pug">
    div.profile-suggestions-control(v-show="show")
        profile-files-container-control(title="Profile Suggestions")
            template(v-slot:actions)
                div.profile-suggestions-control__action-button(:class="actionButtonClass" @click="refresh")
                    svg-icon(iconId="refresh-icon")
            
            template
                div.profile-suggestions-control__list
                    creator-control(v-for="creator in creators" :key="creator.id" :creator="creator")
</template>

<script>
export default {
    name: 'profile-suggestions-control',

    data() {
        return {
            creators: [],
            show: false,
            refreshing: false,
            nextPage: 1,
        }
    },

    computed: {
        actionButtonClass() {
            return {
                'profile-suggestions-control__action-button--loading': this.refreshing,
            }
        },
    },

    methods: {
        load() {
            axios.get(`/api/customer/suggestion/user?page=${this.nextPage}`).then(({data}) => {
                this.creators = data.data
                this.show = this.creators.length > 0
                this.refreshing = false

                const totalPages = data.meta.pagination.total_pages
                this.nextPage++

                if (this.nextPage > totalPages) {
                    this.nextPage = 1
                }
            })
        },

        refresh() {
            this.refreshing = true
            this.load()
        },
    },

    created() {
        this.load()
    },
}
</script>
